export default "__VITE_ASSET__DoCNdlKx__"